module.exports = __webpack_public_path__ + "static/media/physical store.c3c0cc41.svg";